export default __webpack_public_path__ + "img/3a6a9b80653f316afb1831e58edb7c1d.png";